import s from './style.css';
import Chapter from 'components/Chapter';
import TextWithBackground from 'components/TextWithBackground';
import EmojiWordsGraph from 'components/EmojiWordsGraph';
import EmojiGraphFaded from 'components/EmojiGraphFaded';
import RadialChart from 'components/RadialChart';
import ChartTitle from 'components/ChartTitle';
import AreaComparison from 'components/AreaComparison';
import InView from 'components/InView';

const VerbalChanges = ({
	title,
	standFirstPer,
	standFirst,
	text1,
	text2Per,
	text2,
	text3,
	text4,
	text5,
	viz1Title,
	viz1,
	viz2Title,
	viz2,
	viz3Title,
	viz3,
	viz4Title,
	viz4,
	viz5Title,
	viz5,
	viz6Title,
	viz6Text1,
	viz6,
	viz6Text2,
	verbalChangesViz4,
	verbalChangesViz2Title,
	verbalChangesViz2,
	verbalChangesViz2Emoji
}) => (
	<Chapter
		section={3}
		title={title}
		highlight={['45%']}
		standFirst={standFirst}
	>
		<ChartTitle tag="p">{text1}</ChartTitle>
		<ChartTitle tag="p" highlight={['13%']} highlightColors={['yellow']}>
			{text2}
		</ChartTitle>

		<ChartTitle tag="p" bg="#fff">
			{text3}
		</ChartTitle>

		<TextWithBackground
			bg="transparent"
			tag="p"
			highlight={['mocked']}
			highlightColors={['#49BCB3']}
			className={s.tight}
		>
			{text4}
		</TextWithBackground>

		<TextWithBackground
			bg="transparent"
			tag="p"
			className={s.tight}
			highlight={['ashamed']}
			highlightColors={['#7DD4CD']}
		>
			{text5}
		</TextWithBackground>

		<InView
			render={inView => (
				<RadialChart
					data={viz1}
					includePercentage={false}
					fill={'#49BCB3'}
					oddFill={'#7DD4CD'}
					keys={[25, 50]}
					max={50}
					degNum={-6}
					inView={inView}
				/>
			)}
		/>
		<ChartTitle tag="p" flush>
			{verbalChangesViz2Title}
		</ChartTitle>
		<InView
			render={inView => (
				<EmojiGraphFaded
					data={verbalChangesViz2}
					emoji={verbalChangesViz2Emoji}
					inView={inView}
				/>
			)}
		/>
		<ChartTitle tag="p" tight>
			{viz3Title}
		</ChartTitle>
		<ChartTitle tag="p" flush>
			NSFW 🙊
		</ChartTitle>
		<InView
			render={inView => (
				<AreaComparison
					data={viz3}
					masterCircleSize="292"
					masterCirclePercentage="100"
					containerClass={s.viz3Container}
					wrapperClass={s.viz3Wrapper}
					numberClass={s.viz3Number}
					inView={inView}
					color="whiteBlue"
				/>
			)}
		/>
		<ChartTitle tag="p" flush>
			{viz4Title}
		</ChartTitle>
		<InView
			render={inView => (
				<EmojiWordsGraph data={verbalChangesViz4} isEnd inView={inView} />
			)}
		/>
	</Chapter>
);

export default VerbalChanges;



// WEBPACK FOOTER //
// ./components/VerbalChanges/index.js